import React, { Component } from "react";
import socketIOClient from "socket.io-client";
import { httpUploadFile, URLS, httpRequest } from "./../network";
import download from "downloadjs"
import { isNullOrEmpty, SCRAPING_PAGE_TYPE, COURTS, Magistrates, socketQueue, unMountedComponentState } from "./../utils";

import './../css/pjud.css';

class PoderJudicial extends Component {

    constructor() {
        super();
      
        this.state = {
            filePath: "",
            fileName: "",
            fileChoicePath: "",
            rows: [],
            showLoader: false,
            currentRevision: "",
            courts: {},
            magistrates: [],
            maxRows: 0,
            currentRow: 0
        }

        this.socket = null;
    }

    componentDidMount() {

        let courts = this.state.courts;
        Object.keys(COURTS).forEach( (name) => {
            courts[name] = {
                id: COURTS[name],
                name: name,
                checked: false
            };
        });

        if ( isNullOrEmpty(unMountedComponentState[SCRAPING_PAGE_TYPE.PJUD])) {
            unMountedComponentState[SCRAPING_PAGE_TYPE.PJUD] = {
                mounted: true
            }
        }

        unMountedComponentState[SCRAPING_PAGE_TYPE.PJUD].mounted = true;

        let tmpState = { courts: courts };
        if (socketQueue["PJUD"]) {

            this.socket = socketQueue["PJUD"].socket;
            
            tmpState.rows = socketQueue["PJUD"].rows;
            tmpState.currentRow = socketQueue["PJUD"].currentRow;
            tmpState.maxRows = socketQueue["PJUD"].maxRows;
            tmpState.showLoader = true;

            this._onIncominRowSocket(this.socket);
            this._onProcessSocket(this.socket);
            this._onErrorSocket(this.socket);
            this._onProcessEndSocket(this.socket);
        }

        this.setState( tmpState );
        this.fileSelector = this.buildFileSelector();
    }

    componentWillUnmount() {

        if ( !isNullOrEmpty(socketQueue["PJUD"])) {

            socketQueue["PJUD"].rows = this.state.rows;
            socketQueue["PJUD"].currentRow = this.state.currentRow;
            socketQueue["PJUD"].maxRows = this.state.maxRows;

            socketQueue["PJUD"].socket.off("on_rows_to_proccess");
            socketQueue["PJUD"].socket.off("on_current_processing");
            socketQueue["PJUD"].socket.off("on_error");
            socketQueue["PJUD"].socket.off("on_process_end");
        }

        if ( !isNullOrEmpty(unMountedComponentState[SCRAPING_PAGE_TYPE.PJUD])) {
            unMountedComponentState[SCRAPING_PAGE_TYPE.PJUD].mounted = false;
        }
    }

    _updateState = (nState) => {
        this.setState(nState);
    }

    componentDidUpdate() {
        this.scrollToBottom();
    }

    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
    }
    
    buildFileSelector = () => {
		
        const fileSelector = document.createElement("input");
        fileSelector.setAttribute("type", "file");
        fileSelector.setAttribute("multiple", "multiple");
    
        fileSelector.onchange = this.parseFile();
        return fileSelector;
    };

    parseFile = () => (e) => {

        const file = e.target.files[0];
        this.setState({fileChoicePath: file, fileName: file.name });
    };
        
    onFileClickSelect = () => (e) => {
        e.preventDefault();
        this.fileSelector.click();
    };

    setSocketHandlers = (socket) => {

        socket.on("connection", (data) => {
            console.log (data)            
        });

        this._onIncominRowSocket(socket);
        this._onProcessEndSocket(socket);
        
        socket.on("on_rows_to_proccess", (rowsNumber) => {

            if ( !isNullOrEmpty(socketQueue["PJUD"])) {
                socketQueue["PJUD"].maxRows = rowsNumber;
            }
            
            if (!unMountedComponentState[SCRAPING_PAGE_TYPE.PJUD].mounted) {
                return;
            }

            this.setState({maxRows: rowsNumber});
        });

        this._onErrorSocket(socket);
        this._onProcessSocket(socket);
    }

    _onProcessEndSocket = (socket) => {

        socket.on ("on_process_end", (filename) => {
            
            if ( isNullOrEmpty(socket)) {
                console.log ("proceso termino segunda vez");
                return;
            }

            socket.emit("disconnect");
            socket.disconnect();
            delete socketQueue["PJUD"];

            fetch(URLS.DOWNLOAD_FILE + "?file="+filename)
                .then ((res) => {
                    return res.blob();
                })
                .then ( (blob) => {
                    download(blob, "poder_judicial_resultado.xls", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");

                    if (!unMountedComponentState[SCRAPING_PAGE_TYPE.PJUD].mounted) {
                        return;
                    }

                    this._updateState({ showLoader: false, currentRevision: "", currentRow: 0 })
                })
                .catch( (err) => {
                    console.log (err);
                })
        });
    }

    _onIncominRowSocket = (socket) => {

        socket.on("on_row_incoming", (data) => {
            
            const json = JSON.parse(data);
        
            let currentrows = this.state.rows;
            currentrows.push(json.tender);

            if ( !isNullOrEmpty(socketQueue["PJUD"])) {
                socketQueue["PJUD"].rows = currentrows;
            }

            if (!unMountedComponentState[SCRAPING_PAGE_TYPE.PJUD].mounted) {
                return;
            }

            this._updateState({
                rows: currentrows,
                currentRevision: "Revisando rut " + json.tender.rut
            });
            
        });
    }

    _onErrorSocket = (socket) => {

        socket.on("on_error", (err) => {
            
            this.props.errorMessage(err.message);
            socket.emit("disconnect");
            socket.disconnect();

            delete socketQueue["PJUD"];
            if (!unMountedComponentState[SCRAPING_PAGE_TYPE.PJUD].mounted) {
                return;
            }

            this._updateState({ showLoader: false, currentRevision: "", currentRow: 0 })
        });
    }

    _onProcessSocket = (socket) => {

        socket.on("on_current_processing", (data) => {

            if ( !isNullOrEmpty(socketQueue["PJUD"])) {
                socketQueue["PJUD"].currentRow = data.number;
            }
            
            if (!unMountedComponentState[SCRAPING_PAGE_TYPE.PJUD].mounted) {
                return;
            }

            this._updateState({currentRevision: "Revisando rut " + data.rut, currentRow: data.number})
        });
    }
    
    onBackgroundProccessClick = async () => {

        if ( isNullOrEmpty( this.state.fileName)) {
            this.props.errorMessage("Debes cargar primero un archivo!");
            return;
        }

        const fileData = await httpUploadFile(URLS.UPLOAD_FILE, { newFile: this.state.fileChoicePath});
        this.setState({ rows: [], showLoader: false, fileName: fileData.realname, currentRevision: "", currentRow: 0 });

        let selectedCourts = [];
        const courtKeys = Object.keys(this.state.courts);
        courtKeys.forEach( (key) => { if ( this.state.courts[key].checked ) { selectedCourts.push(this.state.courts[key]); } });
        if (selectedCourts.length === 0) {

            this.props.errorMessage("Tienes que seleccionar al menos una corte!");
            return;
        }

        let selectedMagistrates = this.state.magistrates.filter((magis) => { return magis.checked; });
        if (selectedMagistrates.length === 0) {

            this.props.errorMessage("Tienes que seleccionar al menos tribunal!");
            return;
        }

        const params = {
            filePath: fileData.path, 
            court: selectedCourts, 
            magistrate: selectedMagistrates
        };

        httpRequest(URLS.PJUD_BACKGROUND, params, "POST")
            .then ((resp) => {

                if (!resp.success) {
                    this.props.errorMessage(resp.message);
                    return;
                }

                this.props.errorMessage("El archivo sera procesado en el servidor. \nCuando este listo podras revisarlo en la pestaña de \"Trabajos en Background\" ");
            })
            .catch ((err) => {
                this.props.errorMessage(err);
            });
    }

    onSearchClick = async () => {
        
        if ( isNullOrEmpty( this.state.fileName)) {
            alert("Debes cargar primero un archivo!");
            return;
        }

        const fileData = await httpUploadFile(URLS.UPLOAD_FILE, { newFile: this.state.fileChoicePath});
        
        if (isNullOrEmpty(this.socket) && isNullOrEmpty(socketQueue["PJUD"]) ) {

            this.socket = socketIOClient(URLS.MAIN_URL, {  query: "type="+ SCRAPING_PAGE_TYPE.PJUD});
            socketQueue["PJUD"] = {
                socket: this.socket,
                rows: [],
                currentRow: 0,
                maxRows: 0
            };
        }
        else if (!isNullOrEmpty(socketQueue["PJUD"]) ) { 
            this.socket = socketQueue["PJUD"].socket; 
        }
        
        this.setSocketHandlers(this.socket);

        this.setState({ rows: [], showLoader: true, fileName: fileData.realname, currentRevision: "", currentRow: 0 });

        let selectedCourts = [];
        const courtKeys = Object.keys(this.state.courts);
        courtKeys.forEach( (key) => { if ( this.state.courts[key].checked ) { selectedCourts.push(this.state.courts[key]); } });

        let selectedMagistrates = this.state.magistrates.filter((magis) => { return magis.checked; });

        const params = {
            filePath: fileData.path, 
            court: selectedCourts, 
            magistrate: selectedMagistrates
        };

        this.socket.emit("process_start", params);
    }

    magistrateCheckHandler = (index, id = "", firstTime = false) => (e) => {

        let magistrates = this.state.magistrates;
		const nIndex = parseInt(index, 10);
		if (nIndex === -1) { // Todos choice selected

            let checkboxes = document.getElementsByName("tribunal");
			if ( isNullOrEmpty(checkboxes) || checkboxes.length === 0) {
				return;
			}

			let check = checkboxes[0].checked;
			magistrates.forEach( (magistrate) => {
                magistrate.checked = check;
            });
		}
		else {

            magistrates[index].checked = !magistrates[index].checked;
        }

		this.setState({magistrates: magistrates});
	}

    onCourtChecked = (event) =>{ 

        const name = event.target.name;
        let courts = this.state.courts;
        courts[name].checked = !courts[name].checked;

        const courtMagistrates = Magistrates[parseInt(courts[name].id)];

        let magistrates = this.state.magistrates;
        let toConcat = [];
        Object.keys(courtMagistrates).forEach( (key) => {
            toConcat.push({ id: courtMagistrates[key], name: key, checked: false, parent_court: courts[name].id});
        });

        if (courts[name].checked ) {
            magistrates = magistrates.concat(toConcat);
        }
        else {
            
            toConcat.forEach((magis) => {
                
                for (let idx = 0; idx < magistrates.length; idx++) {

                    const m = magistrates[idx];
                    if (m.name === magis.name) {
                        magistrates.splice(idx, 1);
                        idx = -1;
                    }
                }
            });
        }

        this.setState({courts: courts, magistrates: magistrates});
    }

    render () {
        return (
            <div className="pjud-container">
                <h3>Poder Judicial busqueda de roles</h3>
                <p>
                    La búsqueda de rol corresponde a búsqueda por RUT dentro del poder judicial. En el archivo que se suba debe venir el rut y la fecha a la cual se quiere revisar.<br />
                    Se deja para descargar un archivo de ejemplo.
                    <a href={URLS.MAIN_URL + "assets/pjud_ejemplo_rut.xlsx"}>
                        <span className="fas fa-file-excel pjud-excel-icon" title="Documento de ejemplo"></span>
                    </a>
                </p>
                
                <div className="pjud-option-container">
                    <fieldset className="scheduler-border" >
                        <legend className="scheduler-border">Selecciona el archivo con los ruts a buscar</legend>
                        <div className="filter-doc-file">
                            <input type="text" id="filterIdsTxt" className="form-control"
                                placeholder="Selecciona archivo" value={this.state.fileName}/>
                            <button className="btn btn-outline-primary" onClick={this.onFileClickSelect()}> Abrir</button>
                        </div>
                    </fieldset>

                    <div className="pjud-filter-container">
                        <div className="pjud-filter-courts">
                            Cortes
                            <div>
                            {
                                Object.keys(this.state.courts).map( (key, index) => {
                                    return (
                                        <div key={index}>
                                            <input type="checkbox" id="scales" name={key} 
                                                    checked={this.state.courts[key].checked} 
                                                    value={this.state.courts[key].id} 
                                                    onChange={this.onCourtChecked} />

                                            <label htmlFor={key}>{key}</label>
                                        </div>
                                    );
                                })
                            }
                            </div>
                        </div>
                        
                        <div className="pjud-filter-courts">
                            Tribunales
                            <div id="tribunals" className="select-cap">
                                <input type="checkbox" name="tribunal" value="-1" onChange={this.magistrateCheckHandler(-1)}/>
                                <label>Todos</label>
                                {
                                    this.state.magistrates.length > 0 &&
                                        this.state.magistrates.map( (magis, index) => {

                                            return (
                                                <div key={index} style={{margin: 5}} >
                                                    <input type="checkbox" name="tribunal" 
                                                        value={magis.id} 
                                                        checked={ magis.checked}
                                                        onChange={this.magistrateCheckHandler(index, magis.id)} />
                                                    <label>{magis.name}</label>
                                                </div>
                                            )
                                        })
                                }
                            </div>
                        </div>
                    </div>
                    
                </div>

                <div className="progress-container">
                    {this.state.currentRevision}
                    <div className="progress-state">
                        { this.state.showLoader && <div id="loader" className="loader-seia"></div> }
                        <label id="currentProgress">{"Leido " + this.state.currentRow + " de " + this.state.maxRows}</label>
                    </div>
                    <div className="pjud-btn-containers">
                        <button className="btn btn-outline-primary" onClick={this.onSearchClick}>Buscar</button>
                        <button className="btn btn-outline-primary" onClick={this.onBackgroundProccessClick}>Proceso Background</button>
                    </div>
                    
                </div>
                
                <div id="tableContainer" className="result-table">
                    <table className="table table-striped table-fixed">
                        <thead>
                            <tr>
                                <th scope="col">Rut</th>
                                <th scope="col">Rol</th>
                                <th scope="col">Fecha</th>
                                <th scope="col">Caratulado</th>
                                <th scope="col">Tribunal</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.rows.map( (row, index) => {
                                    
                                    return (
                                        <tr key={index}>
                                            <td className="first-table-row">{row.rut}</td>
                                            <td >{row.rol}</td>
                                            <td>{row.date}</td>
                                            <td>{row.description}</td>
                                            <td>{row.magistrate }</td>
                                        </tr>
                                    );
                                })   
                            }
                        
                        </tbody>
                    </table>
                    <div style={{ float:"left", clear: "both" }}
                        ref={(el) => { this.messagesEnd = el; }}>
                    </div>
                </div>
            </div>
        );
    }
    
}

export default PoderJudicial;